import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/sources/edge-gateways/$id/messages/$app/")({
  staticData: {
    title: "edge.navigation.messages",
  },
  loader: ({ params }) =>
    redirect({ to: "/sources/edge-gateways/$id/messages/$app/$tab", params: { id: params.id, app: params.app, tab: "Status" } }),
});
